<template>
  <div>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="TURNOS" key="1">
          <g-master name="shift_setup"
                    :endpoint="shiftMaster.endpoint"
                    :tableSetup="shiftMaster.tableSetup"
                    :modalFieldsSetup="shiftMaster.modalFieldsSetup"
                    :useMultipart="true"

          >
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[48, 24]">
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Nombre turno">
                    <a-input
                      v-decorator="['code', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item label="Descripción" v-bind="fiOptions">
                    <a-input
                      v-decorator="['description', { rules: [{ required: false}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Activo: " :has-feedback="false">
                    <a-checkbox
                      v-decorator="['status', {valuePropName: 'checked' }]">
                    </a-checkbox>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
        </a-tab-pane>
      </a-tabs>
    </a-row>

    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="LOGISTICA DEL TURNO" key="1">
          <shift-master v-if="idShiftSetupType" :id_type="idShiftSetupType"></shift-master>
          <span v-else>Seleccione un turno para ver más.</span>
        </a-tab-pane>
      </a-tabs>
    </a-row>
  </div>
</template>

<script>
  import HttpUtil from '@/util/HttpUtil'
  export default {
    data () {
      return {
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {},
          'has-feedback': true
        },
        shiftMaster: {
          endpoint: 'shift_setup_type',
          tableSetup: {
            tableConfig: { //
              rowKey: 'id'
            },
            columns: [
              {title: 'Código', dataIndex: 'code', sorter: true},
              {title: 'Descripción', dataIndex: 'description', sorter: true},
              {title: 'Estado', dataIndex: 'estado', sorter: true}
            ],

            allowSelect: true,
            selectedRows: []
          },
          actions: {
            actions: [
              {
                name: 'masterEdit',
                text: 'Editar',
                permisos: [],
                props: {size: 'small', type: 'link', icon: 'edit'}
              },
              {
                name: 'masterDelete',
                text: 'Eliminar',
                permisos: [],
                props: {size: 'small', icon: 'delete', type: 'link'}
              }
            ]
          },
          modalFieldsSetup: [
            {name: 'code'},
            {name: 'description'},
            {name: 'status'}
          ]

        }

      }
    },
    computed: {
      idShiftSetupType () {
        return this.shiftMaster.tableSetup.selectedRows.length > 0 ? this.shiftMaster.tableSetup.selectedRows[0].id : null
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Shift/ShiftSetupType.vue